import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import styles from './Pagination.module.css';

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const Pagination = ({
  page,
  pageCount,
  pageSize,
  totalItems,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = PAGE_SIZE_OPTIONS,
}) => {
  const safePage = Math.max(1, Math.min(page, Math.max(1, pageCount)));
  const start = totalItems === 0 ? 0 : (safePage - 1) * pageSize + 1;
  const end = Math.min(totalItems, safePage * pageSize);

  return (
    <div className={styles.pagination}>
      <div className={styles.info}>
        {totalItems === 0 ? (
          <span>No results</span>
        ) : (
          <span>
            Showing <strong>{start}</strong>–<strong>{end}</strong> of{' '}
            <strong>{totalItems}</strong>
          </span>
        )}
      </div>

      <div className={styles.controls}>
        {onPageSizeChange && (
          <label className={styles.pageSize}>
            <span>Rows</span>
            <select
              value={pageSize}
              onChange={(e) => onPageSizeChange(Number(e.target.value))}
            >
              {pageSizeOptions.map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
          </label>
        )}

        <div className={styles.pager}>
          <button
            type="button"
            className={styles.pageBtn}
            onClick={() => onPageChange(safePage - 1)}
            disabled={safePage <= 1}
            aria-label="Previous page"
          >
            <FiChevronLeft />
          </button>
          <span className={styles.pageLabel}>
            Page <strong>{safePage}</strong> of <strong>{Math.max(1, pageCount)}</strong>
          </span>
          <button
            type="button"
            className={styles.pageBtn}
            onClick={() => onPageChange(safePage + 1)}
            disabled={safePage >= pageCount}
            aria-label="Next page"
          >
            <FiChevronRight />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
